// extracted by mini-css-extract-plugin
module.exports = {"apiVersion":"APIVersionSwitcher_apiVersion__z4g1C","wrapper":"APIVersionSwitcher_wrapper__vpK6Q","apiVersionText":"APIVersionSwitcher_apiVersionText___q_at"};